/* eslint-disable @typescript-eslint/camelcase */
import { all, takeEvery } from 'redux-saga/effects'
import * as questionActions from 'components/question/actions'
import * as filterActions from 'components/filter/actions'
import * as demographicActions from 'components/demographics/actions'
import { ActionType } from 'typesafe-actions'

type QuestionActions = ActionType<typeof questionActions>
type FilterActions = ActionType<typeof filterActions>
type DemographicActions = ActionType<typeof demographicActions>

function* answerQuestions() {
  // @ts-ignore
  yield takeEvery<QuestionActions>(
    (action: QuestionActions) => /^answer/.test(action.type),
    (action: QuestionActions) => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: `${action.type}:${action.payload.questionIndex}`
      })
    }
  )
}

function* changeFilters() {
  // @ts-ignore
  yield takeEvery<FilterActions>(
    (action: FilterActions) => /^filter/.test(action.type),
    (action: FilterActions) => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: `${action.type}:${
          action.payload ? (action.payload as string) : 'unset'
        }`
      })
    }
  )
}

function* answerDemographics() {
  // @ts-ignore
  yield takeEvery<DemographicActions>(
    (action: DemographicActions) => /^demographics/.test(action.type),
    (action: DemographicActions) => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: action.type
      })
    }
  )
}

export function* analyticsWatcher() {
  yield all([answerQuestions(), changeFilters(), answerDemographics()])
}
